module.exports = __webpack_public_path__ + "static/jake-dexheimer-db749d71910e44b2794a671b7e33ec56.png";